export const iconFontAwesomeHouseholdDungeon = (
	<i className="fa-solid fa-dungeon"></i>
);
